import { NgModule } from "@angular/core";

import { NSAngular } from "../../../shared/types";

import { CommonModule } from "@angular/common";
import { HexButtonModule } from "@hex/angular/button";
import { HexButtonBarModule } from "@hex/angular/button-bar";
import { HexIconModule } from "@hex/angular/icon"
import { HexModalScreenModule } from "@hex/angular/modal-screen";
import { HexPanelModule } from "@hex/angular/panel"
import { HexTextModule } from "@hex/angular/text"
import { SharedPipesModule } from "../../pipes/pipes.module"
import { LogoutWarningActions } from "./logout-warning-actions";
import { LogoutWarningSelectors } from "./logout-warning-selectors";
import { LogoutWarningComponent } from "./logout-warning.component";

export const MODULE_IMPORTS: NSAngular.Import[] = [
    CommonModule,
    HexModalScreenModule,
    HexButtonBarModule,
    HexButtonModule,
    HexPanelModule,
    HexTextModule,
    HexIconModule,
    SharedPipesModule,
];

export const MODULE_PROVIDERS: NSAngular.Provider[] = [
    LogoutWarningComponent,
    LogoutWarningSelectors,
    LogoutWarningActions,
];

@NgModule({
    imports: MODULE_IMPORTS,
    exports: [
        LogoutWarningComponent,
    ],
    providers: MODULE_PROVIDERS,
    declarations: [
        LogoutWarningComponent,
    ],
})
export class LogoutWarningModule {
}
